export default "__VITE_ASSET__BL3ymUp0__"